import { Sparkles, BookOpen, Library, GraduationCap, Mic, Flame, Trophy, CalendarCheck, ScrollText, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS = {
  sparkles: Sparkles, "book-open": BookOpen, library: Library, "graduation-cap": GraduationCap,
  mic: Mic, flame: Flame, trophy: Trophy, "calendar-check": CalendarCheck, "scroll-text": ScrollText,
};

export const BadgeItem = ({ badge }) => {
  const Icon = ICONS[badge.icon] || Sparkles;
  return (
    <div
      className={cn(
        "flex flex-col items-center text-center gap-2 p-4 rounded-3xl border transition-all",
        badge.earned
          ? "bg-accent/10 border-accent/30 shadow-[0_4px_16px_rgba(241,196,15,0.12)]"
          : "bg-slate-50 border-slate-100 opacity-70",
      )}
      data-testid={`badge-${badge.id}`}
    >
      <div className={cn(
        "w-14 h-14 rounded-2xl flex items-center justify-center relative",
        badge.earned ? "bg-accent text-white" : "bg-slate-200 text-slate-400",
      )}>
        <Icon className="w-7 h-7" />
        {!badge.earned && (
          <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-white border border-slate-200 flex items-center justify-center">
            <Lock className="w-3 h-3 text-slate-400" />
          </div>
        )}
      </div>
      <div>
        <div className="font-extrabold text-sm text-slate-700">{badge.name}</div>
        <div className="text-[11px] text-slate-400">{badge.desc}</div>
      </div>
    </div>
  );
};
